import { Logger } from 'aws-amplify';
import { useContext, useEffect, useState } from 'react';

import { FlagsContext } from 'src/context';
import { RootState } from 'src/store';
import { isUnreadNotification } from 'src/utils/NotificationsUtils';

import { useAppSelector } from '../useStore';

const logger = new Logger('ContractNotificationsBadge');

export const useContractsNotificationCount = (): number => {
  const { EnableManyCompanies } = useContext(FlagsContext);
  const activeCompanyId = useAppSelector(
    (state: RootState) => state.activeCompany.activeCompanyId,
  );

  const notifications = useAppSelector(
    (state: RootState) => state.notifications.esigRequestNotifications,
  );

  // Filter notifications by company if EnableManyCompanies is true
  const filteredNotifications = EnableManyCompanies
    ? notifications.filter((notif) => notif.companyId === activeCompanyId)
    : notifications;

  const [notificationsCounter, setNotificationsCounter] = useState(0);

  useEffect(() => {
    logger.debug('Setting primary contracts sidebar notification');
    // filter unread notification
    logger.debug('Total notifications:', filteredNotifications.length);
    const unreadNotifications = filteredNotifications.filter((notif) =>
      isUnreadNotification(notif.ownerId),
    );

    logger.debug('Unread notifications:', unreadNotifications.length);

    setNotificationsCounter(unreadNotifications.length);
  }, [filteredNotifications]);

  return notificationsCounter;
};
